import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../../Extra/Loading";
import { getCurrentFY } from "../../Utilitie";
import CrewUtilizationTable from "./CrewUtilizationTable";
import CrewUtilizationFilter from "./CrewUtilizationFilter";
import CrewUtilizationGraph from "./CrewUtilizationGraph";
import { data } from "react-router-dom";
import CUCategoryMaster from "./CUCategoryWise/CUCategoryMaster";

const opState = {
  Year: false,
  Months: false,
  Lobby: false,
};
const CrewUtilizationMaster = () => {
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [passedCD, setPassedCD] = useState(null);
  const urlPrefixBlock = process.env.REACT_APP_URL_CMS_PREFIX;
  const [fetchedData, setFetchedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(getCurrentFY().slice(0, 4));
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // last 10 years
  const fetchData = async (year) => {
    // let year = getCurrentFY().slice(0, 4);
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}fetch_cms_utilization?ut_year=${year}`,
      );
      // console.log(response);
      setFetchedData(response.data.current_data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };
  // console.log({ fetchedData }, loading);
  useEffect(() => {
    fetchData(year);
  }, [year]);

  return (
    <div
      onClick={() => {
        setOpenStates(opState);
      }}
    >
      <div>{loading && <Loading />}</div>

      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <div>
          <h5>Crew Utilization Report</h5>
        </div>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(2, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {fetchedData && (
        <div className="sticky-controller">
          <CrewUtilizationFilter
            data={fetchedData}
            setSelectedFilters={setSelectedFilters}
            setFilteredData={setFilteredData}
            openStates={openStates}
            setOpenStates={setOpenStates}
          />
          {/* <div>
            <KpiCards data={filteredData} />
          </div> */}
        </div>
      )}
      {filteredData && (
        <div>
          <CrewUtilizationGraph
            data={filteredData}
            setPassedCD={setPassedCD}
            selectedFilters={selectedFilters}
          />
          <div className="newUiBody">
            <CUCategoryMaster data={filteredData} passedCD={passedCD} />
          </div>
          <CrewUtilizationTable data={filteredData} />
        </div>
      )}
    </div>
  );
};
export default CrewUtilizationMaster;
